/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconSpeechBubbleLineComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 32 32">
    <g id="bubble_chat" data-name="bubble chat">
    <path d="M26,4H6A2.92,2.92,0,0,0,3,6.86V20.14A2.92,2.92,0,0,0,6,23h5.57l3.7,4.37a1,1,0,0,0,1.52,0L20.46,23H26a2.92,2.92,0,0,0,3-2.86V6.86A2.92,2.92,0,0,0,26,4Zm1,16.14A.93.93,0,0,1,26,21H20a1,1,0,0,0-.76.35L16,25.17l-3.24-3.82A1,1,0,0,0,12,21H6a.93.93,0,0,1-1-.86V6.86A.93.93,0,0,1,6,6H26a.93.93,0,0,1,1,.86Z" />
</g>
  </Icon>
);
};

IconSpeechBubbleLineComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgd2lkdGg9IjUxMiIgaGVpZ2h0PSI1MTIiPgogIDxnIGlkPSJidWJibGVfY2hhdCIgZGF0YS1uYW1lPSJidWJibGUgY2hhdCI+CiAgICA8cGF0aCBkPSJNMjYsNEg2QTIuOTIsMi45MiwwLDAsMCwzLDYuODZWMjAuMTRBMi45MiwyLjkyLDAsMCwwLDYsMjNoNS41N2wzLjcsNC4zN2ExLDEsMCwwLDAsMS41MiwwTDIwLjQ2LDIzSDI2YTIuOTIsMi45MiwwLDAsMCwzLTIuODZWNi44NkEyLjkyLDIuOTIsMCwwLDAsMjYsNFptMSwxNi4xNEEuOTMuOTMsMCwwLDEsMjYsMjFIMjBhMSwxLDAsMCwwLS43Ni4zNUwxNiwyNS4xN2wtMy4yNC0zLjgyQTEsMSwwLDAsMCwxMiwyMUg2YS45My45MywwLDAsMS0xLS44NlY2Ljg2QS45My45MywwLDAsMSw2LDZIMjZhLjkzLjkzLDAsMCwxLDEsLjg2WiIvPgogIDwvZz4KPC9zdmc+";
IconSpeechBubbleLineComponent.Content = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="512" height="512">
  <g id="bubble_chat" data-name="bubble chat">
    <path d="M26,4H6A2.92,2.92,0,0,0,3,6.86V20.14A2.92,2.92,0,0,0,6,23h5.57l3.7,4.37a1,1,0,0,0,1.52,0L20.46,23H26a2.92,2.92,0,0,0,3-2.86V6.86A2.92,2.92,0,0,0,26,4Zm1,16.14A.93.93,0,0,1,26,21H20a1,1,0,0,0-.76.35L16,25.17l-3.24-3.82A1,1,0,0,0,12,21H6a.93.93,0,0,1-1-.86V6.86A.93.93,0,0,1,6,6H26a.93.93,0,0,1,1,.86Z"/>
  </g>
</svg>`;

const IconSpeechBubbleLine = styled(IconSpeechBubbleLineComponent)``;

export default IconSpeechBubbleLine;
